export default "__VITE_ASSET__OuRuhmnJ__"